import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Box } from '@material-ui/core';

export default function MetricByBannerChart({ chartData, metricLabel, isPercent }) {
  const labels = (chartData || []).map((d) => d.banner_name);
  const values = (chartData || []).map((d) => d.value);

  const chartConfig = {
    labels,
    datasets: [
      {
        label: metricLabel,
        data: values,
        backgroundColor: '#2196F3',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: `${metricLabel}${isPercent ? ' (%)' : ''} by Banner`,
      },
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: (v) => (isPercent ? `${v}%` : v),
        },
      }],
    },
  };

  return (
    <Box height={320}>
      <Bar data={chartConfig} options={options} />
    </Box>
  );
}
